module.exports = __webpack_public_path__ + "static/media/one_to_one.c8b42ad5.svg";